import moment from 'moment-timezone'

const DEFAULT_WINDOW_DAYS = 7

/**
 * Show an indicator for a limited window after a patient's enrollment was created
 * via a follow-up program transition, so coaches know it happened without needing
 * to reset the (already-retained) care team.
 */
export const shouldShowFollowUpIndicator = (
  enrolledFromPreviousAdvancedProgram: boolean | null | undefined,
  enrollmentCreatedAt: Date | null | undefined,
  windowDays: number = DEFAULT_WINDOW_DAYS
): boolean => {
  if (!enrolledFromPreviousAdvancedProgram || !enrollmentCreatedAt) {
    return false
  }

  return moment().diff(moment(enrollmentCreatedAt), 'days') <= windowDays
}
